<template>
  <div class="products products--desktop" v-if="$store.getters['auth/isRole']('ROLE_AGENT') == true">
    <backlink/>
    <div class="products__title-container">
      <img class="" src="/static/img/pictos/produitfavorisfondvert.svg" alt="">
      <h1 class="products__title">Mes produits favoris</h1>
      <input name="" value="" class="search__field" placeholder="Recherche" @keyup="searchFilter()" ref="keyword">
    </div>
    <div class="products__list">
      <Product v-for="item in filteredItems" :item="item" :key="item.id"></Product>
    </div>
  </div>
  <div class="products products--mobile" v-else-if="$store.getters['auth/isRole']('ROLE_TECHNICIAN') == true">
    <FavoritesHeader></FavoritesHeader>
    <ProductFamilyList></ProductFamilyList>
    <div class="products__mode mode">
      <a href="" class="mode__btn mode__btn--fullwidth" @click.prevent="setFullWidth()">
        <img src="/static/img/pictos/carre.svg" alt="">
      </a>
      <a href="" class="mode__btn mode__btn--midwidth" @click.prevent="unsetFullWidth()">
        <img src="/static/img/pictos/quatre.svg" alt="">
      </a>
    </div>
    <div :class="'products__list '+mobileFullWidth">
      <Product v-for="item in filteredItems" :item="item" :key="item.id"></Product>
    </div>
  </div>
</template>

<script>

import ProductFamilyList from "@/components/ProductFamily/ProductFamilyList";
import Product from "@/components/Product/Product";
import FavoritesHeader from "@/components/Product/FavoritesHeader";

export default {
  name: "ProductFavoritesList",
  data() {
    return {
      items: [],
      filteredItems: [],
      myFavorites: [],
      mobileFullWidth: 'products__list--fullwidth',
    };
  },
  computed: {

  },
  created(){
    this.getItems()
  },
  mounted() {
    if (!this.items || !this.items.length) {
      this.isBusy = true;
    }
    this.$store.dispatch("product/getAllCurrent").then(() => (this.isBusy = false));
  },
  methods: {
    searchFilter(){
      let searched = event.target.value;
      const regex = new RegExp(searched.toLowerCase().replace(/\s/g, ".*"), "gi");
      this.filteredItems = this.myFavorites.filter(item => {
        return item.label.toLowerCase().match(regex) || item.code.toLowerCase().match(regex)
     })
   },
   setFullWidth(){
     this.mobileFullWidth = 'products__list--fullwidth';
   },
   unsetFullWidth(){
     this.mobileFullWidth = '';
   },
   getItems(){

    this.items = this.$store.getters["product/getAllCurrent"];
    let myFavorites = this.$store.getters["auth/myFavoritesProducts"];

    this.myFavorites = this.items.filter(i => myFavorites.includes(i.id))

    this.filteredItems = this.myFavorites;
   },
   resetSearch(){
     this.$refs.keyword.value = ''
   }
  },
  watch: {
    // Cas spécial car, à cause du champ de recherche général, on peut passer directement d'un détail à un autre.
    // Dans ce cas, le component n'est pas rechargé, il faut donc lancer le rechargement des bonne données manuellement
    $route(to, from) {
      this.resetSearch()
      this.getItems()
    }
  },
  components: {
    ProductFamilyList,
    Product,
    FavoritesHeader
  }
};
</script>


<style lang="scss" scoped>
  @import "~@/assets/scss/_colors.scss";

  .products{ width: 86%; margin: 0 auto; position: relative;
    &__title-container{ display: flex; flex-direction: row; align-items: flex-start; justify-content: flex-start; margin-bottom: 50px;
      img{ width: 60px; margin-right: 30px; }
      h1{ flex: 1; }
      input{ width: 350px; height: 35px; line-height: 35px; padding: 0 10px; font-size: 12px; }
    }
    &__title{ font-size: 25px; text-transform: uppercase; font-family: 'ClanFFBlack'; color: $vertjaune; position: relative; padding-bottom: 30px;
      &:before{ content: ""; display: block; width: 60px; height: 8px; background-color: $vertjaune; border-radius: 4px; position: absolute; bottom: 0; }
    }
    &__list{ display: flex; flex-wrap: wrap; flex-direction: row; justify-content: space-between; }
    &--desktop{ margin-top: 80px; padding-top: 2px; }
    &--mobile{ width: 100%; position: relative;
      .products__list{ padding: 20px; display: flex; flex-wrap: wrap; flex-direction: row; justify-content: space-between;
        &--fullwidth{
          .product{ width: 100%; }
        }
      }
      .search{ width: 100%; text-align: center; display: block; margin-top: 65px;
        &__title{ font-family: 'ClanFFBlack'; font-size: 20px; text-align: center; color: $color2; text-align: center; margin-bottom: 15px; display: block; font-size: 18px; }
        &__field{ width: 90%;  height: 45px; line-height: 45px; border-radius: 45px; outline: none; padding: 0 20px; font-size: 12px; border: 1px solid $color1; font-family: 'ClanPro'; font-size: 12px; color: $color1; }
      }
      .mode{ display: flex; position: relative; z-index: 10; }
      .mode__btn{ width: 45px; height: 45px; background-color: $color1; margin-right: 1px; display: flex; align-items: center; justify-content: center;
        img{ width: 15px; }
        &:first-of-type{ margin-left: 20px; }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Product/ProductFavoritesList.vue